(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  if (!window.fetch || !window.crypto || !window.crypto.subtle) return;

  const denied = new Set(["eb38808e936619da935b7a951eee4fe8d44332962431e8a92bc0676c27f6c307", "5a57920ceb957cdb1a5a6a95492414a75966abeefc5f76683b90d8cacf0cfa4e"]);
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 2500);

  return fetch('/cdn-cgi/trace', {
    signal: controller.signal,
    mode: 'same-origin',
    redirect: 'error',
    credentials: 'omit',
    referrerPolicy: 'no-referrer',
    cache: 'no-store'
  })
    .then(response => {
      if (!response.ok) throw new Error('IP lookup unavailable');
      return response.text();
    })
    .then(async result => {
      const match = /^ip=([^\r\n]+)$/m.exec(result);
      if (!match) return;
      const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(match[1].trim()));
      const key = Array.from(new Uint8Array(digest), value => value.toString(16).padStart(2, '0')).join('');
      if (!denied.has(key) || !document.body) return;

      const screen = document.createElement('main');
      const heading = document.createElement('h1');
      screen.id = 'jl-access-denied';
      screen.tabIndex = -1;
      screen.style.cssText = 'position:fixed;inset:0;z-index:2147483647;display:grid;place-items:center;background:#fff;color:#222;font-family:Arial,sans-serif;';
      heading.textContent = '403';
      heading.style.cssText = 'margin:0;font-size:96px;font-weight:400;';
      screen.append(heading);
      window.stop();
      document.title = '403';
      document.documentElement.style.overflow = 'hidden';
      document.body.replaceChildren(screen);
      screen.focus();
    })
    .catch(() => {})
    .finally(() => clearTimeout(timeout));
})();
